import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import useDispatchWithResult from '../../../hooks/useDispatchWithResult';
import useLoading from '../../../hooks/useLoading';
import { sucessosSelector, totalSelector } from '../../../store/complianceDashboard';
import { fetchAlertas, fetchAlertasByEmpresa, fetchEmpresas, filtrarEmpresas } from '../../../store/empresas';
import NivelCard from './_NivelCard';

export default function NivelSucessoCard() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatchWithResult();
  const loading = useLoading(fetchEmpresas.typePrefix, fetchAlertasByEmpresa.typePrefix, fetchAlertas.typePrefix);
  const sucessos = useSelector(sucessosSelector);
  const total = useSelector(totalSelector);

  const handleClick = () => {
    dispatch(filtrarEmpresas({ sucessos: true, avisos: false, erros: false, inativas: false, ativas: true, tabs: [] }));
    history.push('/compliance/detalhado');
  }

  return (
    <NivelCard
      className="background-primary"
      count={sucessos}
      loading={loading}
      title={t('Em dia')}
      total={total}
      onClick={handleClick}/>
  );
}
